<!--
 * @Description:
 * @Author: mdb
 * @Date: 2023-04-13 13:53:26
 * @LastEditTime: 2023-04-19 15:48:46
 * @LastEditors: mdb
-->
<template>
  <CardManage :permission="permission" subdomain="fbu" />
</template>

<script setup lang="ts">
import CardManage from '@/views/marketing/marketingManage/cardManage/index.vue'

const permission = {
  add: 'fbu_card_add_btn',
  edit: 'fbu_card_edit_btn',
  del: 'fbu_card_del_btn',
  qrcode: 'fbu_card_qrcode_btn'
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuCardManage' }
</script>

<style scoped></style>
